module.exports = __webpack_public_path__ + "fonts/Roboto-Thin.b8339154.ttf";